<template>
<nav id="newsletter-nav">
  <ul class="nav nav-pills">
    <li>
      <router-link :to="{ name: 'create_newsletter' }">Create Newsletter</router-link>
    </li>
    <li v-if="newsletterId">
      <router-link :to="{ name: 'edit_newsletter', params: { newsletterId: newsletterId }}">Edit Newsletter</router-link>
    </li>
    <li v-if="newsletterId">
      <router-link :to="{ name: 'newsletter_recipients', params: { newsletterId: newsletterId }}">Recipients</router-link>
    </li>
    <li v-if="newsletterId">
      <router-link :to="{ name: 'newsletter_stats', params: { newsletterId: newsletterId }}">Stats</router-link>
    </li>
    <li>
      <router-link :to="{ name: 'newsletter_types' }">Newsletter Types</router-link>
    </li>
    <!--
    <li>
      <router-link :to="{ name: 'newsletter_calendar' }">Newsletter Calendar</router-link>
    </li>
    -->
  </ul>
</nav>
</template>

<script>
export default {
  props: {
    dateStart: {
      type: [ Date, Number, String ],
      default: () => {
        return Date.now()
      }
    },

    dateEnd: {
      type: [ Date, Number, String ],
      default: () => {
        return Date.now()
      }
    },
    newsletterId: {
      type: [ Number, String ]
    }
  }
}
</script>

<style scoped>
main nav {
  margin-bottom: 1em;
}

.nav {
  border-top: 0
}
</style>



// WEBPACK FOOTER //
// src/components/NewsletterNav.vue